import { giphyBlack } from '@giphy/js-brand'
import styled from 'styled-components'
import { IconButton, Loader as LoaderComponent } from 'ui'
import { MAX_PREVIEW_WIDTH } from './constants'

export const Container = styled.div`
    align-items: flex-start;
    display: flex;
    justify-content: center;
    width: 100%;
`

export const Loader = styled(LoaderComponent)`
    margin-top: 80px;
`

export const Panel = styled.div`
    margin: 0 14px;
    width: ${MAX_PREVIEW_WIDTH}px;
`

export const PanelContent = styled.div`
    background: ${giphyBlack};
    border-radius: 6px;
`

export const CloseButton = styled(IconButton)`
    flex-shrink: 0;
    z-index: 1;
`
